import {Title} from '@app/titles/models/title';
import {Episode} from '@app/titles/models/episode';
import {getEpisodeLink} from '@app/episodes/episode-link';
import {getTitleLink} from '@app/titles/title-link';
import {VideoGrid} from '@app/titles/video-grid';
import {SiteSectionHeading} from '@app/titles/site-section-heading';
import {Trans} from '@common/i18n/trans';
import {Button} from '@common/ui/buttons/button';
import {Link} from 'react-router-dom';
import {ArrowForwardIcon} from '@common/icons/material/ArrowForward';
import EmptyData from '../EmptyData';

interface Props {
  title: Title;
  episode?: Episode;
}
export function TitlePageVideoGrid({title, episode}: Props) {
  const videos = episode ? episode.videos : title.videos;
  const link = episode
    ? `${getEpisodeLink(
        title,
        episode.season_number,
        episode.episode_number,
      )}/episodes/${episode.id}/videos`
    : `${getTitleLink(title)}/videos`;
  return (
    <>
      {videos?.length !== 0 ? (
        <>
          <VideoGrid
            videos={videos?.filter(item => item.category === 'trailer')}
            title={title}
            episode={episode}
            count={15}
            // heading={
            //   <SiteSectionHeading link={link}>
            //     <Trans message="Videos" />
            //   </SiteSectionHeading>
            // }
          />
          {videos?.length !== 0 && (
            <Link
              to="primary"
              style={{
                backgroundColor: '#DC2626', // Red color
                color: '#FFFFFF', // White color
                padding: '12px 24px',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                transition: 'all 0.3s ease',
                transform: 'scale(1)',
                width: 'max-content',
                margin: '16px auto',
              }}
              className="hover:scale-105 active:scale-95"
              onMouseOver={e => {
                e.currentTarget.style.backgroundColor = '#B91C1C'; // Darker red on hover
                e.currentTarget.style.boxShadow =
                  '0 6px 12px rgba(0, 0, 0, 0.15)';
              }}
              onMouseOut={e => {
                e.currentTarget.style.backgroundColor = '#DC2626'; // Original red
                e.currentTarget.style.boxShadow =
                  '0 4px 6px rgba(0, 0, 0, 0.1)';
              }}
              onMouseDown={e => {
                e.currentTarget.style.backgroundColor = '#991B1B'; // Even darker red on click
              }}
              onMouseUp={e => {
                e.currentTarget.style.backgroundColor = '#B91C1C'; // Revert to hover state
              }}
            >
              <ArrowForwardIcon />
              <Trans message="All Videos and Trailers" />
            </Link>
          )}
        </>
      ) : (
        <EmptyData />
      )}
    </>
  );
}
